import { useCallback, useEffect, useState } from "react";
const useImageLoad = (src, onErrorCallback, onLoadCallback) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const handleLoad = useCallback((loaded2) => {
    setLoaded(loaded2);
    onLoadCallback?.(loaded2);
  }, [onLoadCallback, setLoaded]);
  useEffect(() => {
    handleLoad(false);
    setError(false);
    if (!src)
      return;
    const img = new Image();
    img.src = src;
    const onLoad = () => {
      handleLoad(true);
      setError(false);
    };
    const onError = () => {
      handleLoad(false);
      setError(true);
      onErrorCallback?.();
    };
    img.addEventListener("load", onLoad);
    img.addEventListener("error", onError);
    return () => {
      img.removeEventListener("load", onLoad);
      img.removeEventListener("error", onError);
    };
  }, [src, handleLoad, onErrorCallback]);
  return { loaded, error };
};
export {
  useImageLoad
};
